import { Box } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useContextState } from "../../../../../../../../hooks/theme";
import { useStyles } from "./styles";


export const FinalBoxDaysTranscurredSla = ({ startDate, timeConfig, finishDate }: { finishDate: Dayjs | null, startDate?: Dayjs, timeConfig?: number }) => {

    const styles = useStyles();
    const { colors } = useContextState()
    const [bgColor, setBgColor] = useState(colors.color39);

    useEffect(() => {
            const updateColor = () => {
                if (!timeConfig) {
                    setBgColor(colors.color39);
                    return;
                }
                const endDate = finishDate ?? dayjs();
                const elapsedTime = endDate.diff(startDate, "milliseconds");
                const range = timeConfig / 3; // Dividir el tiempo en 3 partes

                const firstRange = range;
                const secondRange = firstRange + range;
                const thirdRange = secondRange + range;
    
                if (elapsedTime < firstRange) setBgColor(colors.color8); // Primer tramo
                else if (elapsedTime < secondRange) setBgColor(colors.color34); // Segundo tramo
                else setBgColor(colors.color19); // Último tramo
            };
    
            updateColor(); // Llamar la primera vez
            const interval = setInterval(updateColor, 1000); // Actualizar cada segundo
    
            return () => clearInterval(interval); // Limpiar el intervalo al desmontar
        }, [timeConfig, startDate]);


    return (
        <Box sx={styles.rightBox(bgColor)} />
    );
};
